export default __webpack_public_path__ + "static/media/1 - Lurkin' Turnips.ba014ded.jpg";